<template>
  <div v-if="friend">
    <picture>
      <source
        srcset="@/assets/images/village/signpost.webp 700w"
        type="image/webp"
        sizes="500px"
      >
      <img
        class="sign__post"
        alt="Signpost"
        src="@/assets/images/village/signpost.png"
        srcset="@/assets/images/village/signpost.png 700w"
        width="458"
        height="461"
        sizes="500px"
      >
    </picture>
    <div class="sign__inner">
      <div class="sign__content">
        <transition name="fade" mode="out-in">
          <div v-if="friend" :key="friend">
            <img
              v-if="friend.AvatarUrl"
              alt="Avatar"
              :src="friend.AvatarUrl"
              class="sign__avatar"
            >
            <p class="sign__title">
              {{ friend.Title }}
            </p>
            <p class="sign__text">
              {{ friend.Summary }}
            </p>
          </div>
        </transition>
      </div>
    </div>
    <div class="sign__btn">
      <button class="btn btn--pink btn--half" @click="clickViewMore()">
        Find out more
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Friend',

  props: {
    friend: {
      default: () => {},
      type: Object
    }
  },

  methods: {
    clickViewMore () {
      if (this.friend.Title) {
        this.$gtm.trackEvent({
          'event': 'View User Story',
          'lp_friendName': this.friend.Title
        })
      }
      this.$store.dispatch('setModal', this.friend)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/mixins.scss';

.sign__post {
  position: absolute;
  z-index: 0;
  left: 0;
  bottom: 0;
  width: 100%;
}
.sign__btn {
  position: absolute;
  z-index: 1;
  bottom: 65px;
  left: 0;
  width: 100%;
  text-align: center;

  @include breakpoint(lg) {
    bottom: 105px;
  }
}
.sign__inner {
  position: absolute;
  z-index: 1;
  bottom: 115px;
  left: 0;
  width: 100%;
  height: 170px;
  padding: 0;
  color: $white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  @include breakpoint(lg) {
    bottom: 160px;
    padding: 0 120px;
    height: 220px;
  }
}
.sign__content {
  display: block;
  margin: 0 auto;
  max-width: 255px;

  @include breakpoint(lg) {
    max-width: none;
  }
}
.sign__title {
  font-size: 2rem;
  line-height: 2.4rem;
  margin-bottom: 3px;

  @include breakpoint(lg) {
    font-size: 2.4rem;
    line-height: 2.8rem;
    margin-bottom: 10px;
  }
}
.sign__text {
  font-size: 1.3rem;
  line-height: 1.7rem;
  margin-bottom: 0;

  @include breakpoint(lg) {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
}
.sign__avatar {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0 auto 5px;
  background-color: $white;

  @include breakpoint(lg) {
    margin: 0 auto 10px;
    width: 80px;
    height: 80px;
  }
}
</style>
